/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const AddPraetorPolicyPlanBody = zod
	.object({
		enabled: zod.boolean().optional().describe('Whether component is enabled'),
		policy_plan_id: zod.uuid(),
		policy_plan_version_id: zod.string().nullish().describe('Optional policy plan version pin'),
		position: zod.number().optional().describe('Optional ordering position')
	})
	.describe('Request body for adding a policy plan component');

export type AddPraetorPolicyPlanBody = zod.input<typeof AddPraetorPolicyPlanBody>;
export type AddPraetorPolicyPlanBodyOutput = zod.output<typeof AddPraetorPolicyPlanBody>;
